import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, renderSlot as _renderSlot, unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withDirectives as _withDirectives, Transition as _Transition } from "vue"

const _hoisted_1 = {
  id: "pg-email-builder-test-email",
  class: "fixed inset-0 overflow-hidden"
}
const _hoisted_2 = { class: "absolute inset-0 overflow-hidden" }
const _hoisted_3 = { class: "absolute inset-y-0 right-0 pl-10 max-w-full flex sm:pl-16" }
const _hoisted_4 = {
  key: 0,
  class: "w-screen max-w-lg"
}
const _hoisted_5 = { class: "h-full flex flex-col bg-white shadow-xl overflow-y-scroll" }
const _hoisted_6 = { class: "flex-1" }
const _hoisted_7 = { class: "px-4 py-6 sm:px-6 border-b border-gray-200" }
const _hoisted_8 = { class: "flex items-start justify-between space-x-3" }
const _hoisted_9 = { class: "space-y-1" }
const _hoisted_10 = { class: "text-2xl leading-7 font-medium mb-2" }
const _hoisted_11 = { class: "text-sm text-gray-400 leading-4" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("svg", {
  class: "h-6 w-6",
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "2",
    d: "M6 18L18 6M6 6l12 12"
  })
], -1)
const _hoisted_13 = [
  _hoisted_12
]
const _hoisted_14 = { class: "py-0 space-y-0" }
const _hoisted_15 = { class: "space-y-1 px-4 sm:space-y-0 sm:grid sm:grid-cols-1 gap-5 padding-x-6 padding-y-5" }
const _hoisted_16 = {
  for: "test-email-from-email-input",
  class: "block text-sm font-medium leading-5 text-gray-500 sm:mt-px sm:pt-2"
}
const _hoisted_17 = { class: "sm:col-span-2 mt-2" }
const _hoisted_18 = { class: "rounded-md shadow-sm" }
const _hoisted_19 = { class: "relative" }
const _hoisted_20 = {
  for: "test-email-from-email-input",
  class: "block text-sm font-medium leading-5 text-gray-500 sm:mt-px sm:pt-2"
}
const _hoisted_21 = { class: "sm:col-span-2 mt-2" }
const _hoisted_22 = { class: "relative" }
const _hoisted_23 = {
  key: 0,
  class: "text-gray-400 text-xs"
}
const _hoisted_24 = { key: 0 }
const _hoisted_25 = {
  for: "test-email-rss-feed-url",
  class: "block text-sm font-medium leading-5 text-gray-500 sm:mt-px sm:pt-2"
}
const _hoisted_26 = { class: "sm:col-span-2 mt-2" }
const _hoisted_27 = { class: "rounded-md shadow-sm" }
const _hoisted_28 = { class: "relative" }
const _hoisted_29 = { class: "text-xs pt-1 text-red-600" }
const _hoisted_30 = { key: 1 }
const _hoisted_31 = {
  for: "pg-emailbuilder-test-email__subject-select",
  class: "block text-sm font-medium leading-5 text-gray-500 sm:mt-px sm:pt-2"
}
const _hoisted_32 = { class: "sm:col-span-2 mt-2" }
const _hoisted_33 = { class: "space-y-1 px-4 sm:space-y-0 sm:grid sm:grid-cols-1 sm:gap-4 padding-x-6 padding-y-5" }
const _hoisted_34 = {
  for: "project_description",
  class: "block text-sm font-medium leading-5 text-gray-500 sm:mt-px sm:pt-2"
}
const _hoisted_35 = { class: "sm:col-span-2" }
const _hoisted_36 = { class: "flex rounded shadow-sm" }
const _hoisted_37 = { class: "relative w-full" }
const _hoisted_38 = { class: "margin-x-5" }
const _hoisted_39 = { class: "text-gray-500" }
const _hoisted_40 = { class: "flex-shrink-0 px-4 bg-gray-50 py-6 sm:px-6" }
const _hoisted_41 = { class: "space-x-3 flex justify-end" }
const _hoisted_42 = { class: "inline-flex rounded-md shadow-sm" }
const _hoisted_43 = { class: "inline-flex rounded-md shadow-sm" }

import {
  computed,
  defineComponent,
  ref,
  watchEffect,
  watch,
  PropType,
  onMounted,
} from 'vue'
import {
  UISelect,
  UIInput,
  UIButton,
  UICheckbox,
  UIFormItem,
  UITextXsMedium,
} from '@gohighlevel/ghl-ui'

import { useValidation } from '../../composable/validation'
import { getInitialScheduleOptions } from 'common/utils/helper'
import { ICustomField, ICustomValue, Menu } from '../../types'
import { hasHandleBar, isValidHandleBars } from '../../utils/helper'
import { PlaySquareIcon } from '@gohighlevel/ghl-icons/24/outline'
import CustomVariablePicker from '../CustomVariablePicker.vue'
import { useField } from 'vee-validate'
import { url } from '@vee-validate/rules'
import CustomIcon from '../../Icons/CustomIcon.vue'
import i18n from '../../locales'
import { builderState } from 'common/composable/manageBuilderState'
import { useNotificationEvent } from 'common/composition/useNotificationEvent'

export default /*#__PURE__*/_defineComponent({
  __name: 'SendTestEmail',
  props: {
  show: {
    type: Boolean,
    default: false,
  },
  hasRSSElement: {
    type: Boolean,
    default: true,
  },
  service: {
    type: Object,
    required: true,
  },
  userId: { type: String, required: true },
  templateId: { type: String, required: true },
  locationId: { type: String, required: true },
  customFieldsLocation: {
    type: Array as PropType<Array<ICustomField>>,
    default: [],
  },
  customValuesLocation: {
    type: Array as PropType<Array<ICustomValue>>,
    default: [],
  },
  subjectOptions: {
    type: Array,
    required: false,
    default: [],
  },
  attachments: {
    type: Array,
    default: [],
  },
  scheduleDetails: {
    type: Object as ISchedule,
  },
  senderPreferences: {
    type: Object,
  },
},
  emits: ['close', 'updateSenderPreference'],
  setup(__props, { emit }) {

const props = __props;



const showContent = ref(false)
const fromEmail = ref<string>('')
const toEmail = ref<string>('')
const rssFeedURL = ref<string>('')
const emailSubject = ref<string>('')
const sendEmailLoader = ref(false)
const showRSSFeedURL = ref(props.hasRSSElement)
const selectedSubjectValue = ref('')
const initialScheduleDetails = ref<IScheduleIntialOptions>({})
const { validateEmail } = useValidation()
const storeAsDefault = ref(false)
const { value, errorMessage: invalidURLMessage } = useField(
  'rss-feed-url',
  url,
  {
    initialValue: rssFeedURL.value,
    validateOnMount: false,
    label: 'RSS Feed URL',
  }
)
const { enableNotification } = useNotificationEvent()


onMounted(() => {
  const scheduleDetails = props.scheduleDetails
  const senderPreferences = props.senderPreferences
  const { subjectLine, ...others } = scheduleDetails || {}

  if (scheduleDetails) {
    if (scheduleDetails.meta)
      initialScheduleDetails.value = getInitialScheduleOptions(scheduleDetails)
    // Campaigns
    else initialScheduleDetails.value = { ...others, subject: subjectLine } // Templates
  }
  fromEmail.value =
    initialScheduleDetails.value?.fromAddress || senderPreferences?.from
  emailSubject.value = initialScheduleDetails.value?.subject
  toEmail.value = props.senderPreferences?.to || ''

  // Override values with builderState if present
  if (builderState.subjectLine) emailSubject.value = builderState.subjectLine
  if (builderState.fromAddress) fromEmail.value = builderState.fromAddress
})

watch(rssFeedURL, val => {
  value.value = val ? val : ''
})

function onClickClose() {
  // donot close if picker is open
  const pickerEl = document.querySelector('.dropdown-tree__container')
  if (pickerEl) return
  showContent.value = false
  setTimeout(() => {
    emit('close')
  }, 500)
}
watch(
  () => props.hasRSSElement,
  val => {
    showRSSFeedURL.value = val
  }
)
watch(selectedSubjectValue, () => {
  if (selectedSubjectValue.value === 'custom') {
    emailSubject.value =
      builderState.subjectLine ?? initialScheduleDetails.value?.subject
  } else {
    emailSubject.value =
      props.subjectOptions[selectedSubjectValue.value as string].data
  }
})
watchEffect(() => {
  showContent.value = props.show
})

async function onClickTestEmail() {
  sendEmailLoader.value = true
  try {
    const { data } = await props.service.getHtmlPreview({
      id: props.templateId as string,
      locationId: props.locationId as string,
    })
    if (data) {
      const recipients = toEmail.value.split(',')
      const messagePreviewPromises = recipients.map(emailId => {
        return props.service.messagePreview({
          email: emailId?.trim(),
          message: data as string,
          from_address: fromEmail.value ?? '',
          location_id: props.locationId as string,
          subject: emailSubject.value ?? '',
          type: 'email',
          user_id: props.userId,
          template_id: props.templateId as string,
          rss_feed_url: rssFeedURL.value as string,
          attachments: props.attachments?.map(
            ({ downloadUrl }: any) => downloadUrl
          ),
        })
      })
      await Promise.all(messagePreviewPromises)
    }

    // update default sender details
    if (storeAsDefault.value) {
      const payload = {
        senderPreferences: {
          from: fromEmail.value,
          to: toEmail.value,
        },
      }
      const { data } = await props.service.updateSettings(
        props.locationId,
        payload
      )
      if (data) emit('updateSenderPreference', data?.senderPreferences)
    }

    enableNotification({
      title: `Email Sent`,
      content: `A test email has been sent to ${toEmail.value}`,
      type: 'success',
    })
    onClickClose()
  } catch (error: any) {
    console.error(error)
    let errorReason = error?.response?.data?.msg
    if (errorReason) {
      if (errorReason.includes('Email body / subject content error')) {
        console.warn(errorReason)
        errorReason = `: ${i18n.global.t('common.invalidCustomVariable')}`
      }
    }
    enableNotification({
      title: i18n.global.t('common.somethingWentWrong'),
      content: i18n.global.t('common.testEmailFailMsg', {
        errorReason: errorReason ? errorReason : '',
      }),
      type: 'error',
    })
  } finally {
    sendEmailLoader.value = false
  }
}

const isValidToAddress = computed(() => {
  if (!toEmail.value) return false
  const emailIds = toEmail.value.split(',')
  if (emailIds.length > 5) return false
  for (let i = 0; i < emailIds.length; i++) {
    const email = emailIds[i].trim()
    const isValid =
      toEmail.value !== '' &&
      (validateEmail(email) ||
        (hasHandleBar(email) && isValidHandleBars(email)))
    if (!isValid) return false
  }
  return true
})

const subjectOptionsInput = computed(() => {
  return props.subjectOptions.length > 0
    ? [...props.subjectOptions, { value: 'custom', label: 'Custom' }]
    : []
})
function updateFromEmail(payload: Menu) {
  if (payload.value) fromEmail.value = payload.value
}
function updateToEmail(payload: Menu) {
  if (payload.value) toEmail.value = payload.value
}
function updateSubject(payload: Menu) {
  if (payload.value) emailSubject.value = payload.value
}
function updateRSSFeedURL(payload: Menu) {
  if (payload.value) rssFeedURL.value = payload.value
}

return (_ctx: any,_cache: any) => {
  const _directive_click_outside = _resolveDirective("click-outside")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("section", _hoisted_3, [
        _createVNode(_Transition, {
          "enter-active-class": "transform transition ease-in-out duration-500 sm:duration-700",
          "enter-class": "translate-x-full",
          "enter-to-class": "translate-x-0",
          "leave-active-class": "transform transition ease-in-out duration-500 sm:duration-700",
          "leave-class": "translate-x-0",
          "leave-to-class": "translate-x-full"
        }, {
          default: _withCtx(() => [
            (showContent.value)
              ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_4, [
                  _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("div", _hoisted_6, [
                      _createElementVNode("header", _hoisted_7, [
                        _createElementVNode("div", _hoisted_8, [
                          _createElementVNode("div", _hoisted_9, [
                            _createElementVNode("h2", _hoisted_10, _toDisplayString(_ctx.$t('common.testEmail')), 1),
                            _createElementVNode("p", _hoisted_11, _toDisplayString(_ctx.$t('common.testEmailHeading')), 1)
                          ]),
                          _createElementVNode("div", { class: "h-7 flex items-center" }, [
                            _createElementVNode("button", {
                              onClick: onClickClose,
                              "aria-label": "Close panel",
                              class: "text-gray-400 hover:text-gray-500 transition ease-in-out duration-150"
                            }, _hoisted_13)
                          ])
                        ])
                      ]),
                      _renderSlot(_ctx.$slots, "default"),
                      _createElementVNode("div", _hoisted_14, [
                        _createElementVNode("div", _hoisted_15, [
                          _createElementVNode("div", null, [
                            _createElementVNode("div", null, [
                              _createElementVNode("label", _hoisted_16, _toDisplayString(_ctx.$t('common.fromAddress')), 1)
                            ]),
                            _createElementVNode("div", _hoisted_17, [
                              _createElementVNode("div", _hoisted_18, [
                                _createElementVNode("div", _hoisted_19, [
                                  _createVNode(_unref(UIInput), {
                                    id: "pg-emailbuilder-test-email__from-email-input",
                                    modelValue: fromEmail.value,
                                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((fromEmail).value = $event)),
                                    placeholder: "mail@example.com",
                                    class: "pr-9 text-gray-400",
                                    error: 
                                fromEmail.value
                                  ? !(
                                      _unref(validateEmail)(fromEmail.value) ||
                                      (_unref(hasHandleBar)(fromEmail.value) &&
                                        _unref(isValidHandleBars)(fromEmail.value))
                                    )
                                  : false
                              
                                  }, null, 8, ["modelValue", "error"]),
                                  _createVNode(CustomVariablePicker, {
                                    id: "__from-email-custom",
                                    "onUpdate:selectedValue": updateFromEmail,
                                    noMarginTop: true,
                                    customFieldsLocation: __props.customFieldsLocation,
                                    customValuesLocation: __props.customValuesLocation
                                  }, null, 8, ["customFieldsLocation", "customValuesLocation"])
                                ])
                              ])
                            ])
                          ]),
                          _createElementVNode("div", null, [
                            _createElementVNode("label", _hoisted_20, _toDisplayString(_ctx.$t('common.sendTestTo')), 1),
                            _createElementVNode("div", _hoisted_21, [
                              _createElementVNode("div", _hoisted_22, [
                                _createVNode(_unref(UIInput), {
                                  id: "pg-emailbuilder-test-email__to-email-input",
                                  modelValue: toEmail.value,
                                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((toEmail).value = $event)),
                                  placeholder: "mail@example.com, johndoe@xyz.com",
                                  class: "pr-9 text-gray-400"
                                }, null, 8, ["modelValue"]),
                                _createVNode(CustomVariablePicker, {
                                  id: "__to-email-custom",
                                  "onUpdate:selectedValue": updateToEmail,
                                  noMarginTop: true,
                                  customFieldsLocation: __props.customFieldsLocation,
                                  customValuesLocation: __props.customValuesLocation
                                }, null, 8, ["customFieldsLocation", "customValuesLocation"])
                              ]),
                              _createVNode(_unref(UITextXsMedium), { class: "text-gray-400 mt-1" }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.$t('emailBuilder.maxEmailWarning')), 1)
                                ]),
                                _: 1
                              }),
                              (_unref(hasHandleBar)(toEmail.value))
                                ? (_openBlock(), _createElementBlock("span", _hoisted_23, _toDisplayString(_ctx.$t('campaignSchedule.emailCustomValuesWarn')), 1))
                                : _createCommentVNode("", true)
                            ])
                          ]),
                          (showRSSFeedURL.value)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                                _createElementVNode("div", null, [
                                  _createElementVNode("label", _hoisted_25, _toDisplayString(_ctx.$t('campaignSchedule.rssFeedUrlInput')), 1)
                                ]),
                                _createElementVNode("div", _hoisted_26, [
                                  _createElementVNode("div", _hoisted_27, [
                                    _createElementVNode("div", _hoisted_28, [
                                      _createVNode(_unref(UIInput), {
                                        id: "pg-emailbuilder-test-email__rss-feed-url",
                                        modelValue: rssFeedURL.value,
                                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((rssFeedURL).value = $event)),
                                        placeholder: "https://example.com/rss-feed",
                                        class: "pr-9 text-gray-400",
                                        error: !!_unref(invalidURLMessage)
                                      }, null, 8, ["modelValue", "error"]),
                                      _createVNode(CustomVariablePicker, {
                                        id: "__rss-feed-custom",
                                        "onUpdate:selectedValue": updateRSSFeedURL,
                                        noMarginTop: true,
                                        customFieldsLocation: __props.customFieldsLocation,
                                        customValuesLocation: __props.customValuesLocation
                                      }, null, 8, ["customFieldsLocation", "customValuesLocation"])
                                    ])
                                  ]),
                                  _createElementVNode("span", _hoisted_29, _toDisplayString(_unref(invalidURLMessage) ? _unref(invalidURLMessage) : ''), 1)
                                ])
                              ]))
                            : _createCommentVNode("", true),
                          (__props.subjectOptions.length > 0)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                                _createElementVNode("div", null, [
                                  _createElementVNode("label", _hoisted_31, _toDisplayString(_ctx.$t('common.selectSubject')), 1)
                                ]),
                                _createElementVNode("div", _hoisted_32, [
                                  _createVNode(_unref(UISelect), {
                                    id: "pg-emailbuilder-test-email__subject-select",
                                    to: false,
                                    value: selectedSubjectValue.value,
                                    "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((selectedSubjectValue).value = $event)),
                                    options: _unref(subjectOptionsInput),
                                    placeholder: _ctx.$t('ABTesting.selectOne'),
                                    class: "sm:col-span-2"
                                  }, null, 8, ["value", "options", "placeholder"])
                                ])
                              ]))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("div", _hoisted_33, [
                          _createElementVNode("div", null, [
                            _createElementVNode("label", _hoisted_34, _toDisplayString(_ctx.$t('common.emailSubject')), 1)
                          ]),
                          _createElementVNode("div", _hoisted_35, [
                            _createElementVNode("div", _hoisted_36, [
                              _createElementVNode("div", _hoisted_37, [
                                _createVNode(_unref(UIInput), {
                                  id: "pg-emailbuilder-test-mail__email_subject_line",
                                  type: "textarea",
                                  modelValue: emailSubject.value,
                                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((emailSubject).value = $event)),
                                  placeholder: _ctx.$t('common.emailSubject'),
                                  rows: 3,
                                  disabled: 
                              __props.subjectOptions.length > 0 &&
                              selectedSubjectValue.value !== 'custom'
                            
                                }, null, 8, ["modelValue", "placeholder", "disabled"]),
                                _createVNode(CustomVariablePicker, {
                                  id: "__email-subject-custom",
                                  class: "items-start -top-10",
                                  "onUpdate:selectedValue": updateSubject,
                                  noMarginTop: true,
                                  customFieldsLocation: __props.customFieldsLocation,
                                  customValuesLocation: __props.customValuesLocation
                                }, null, 8, ["customFieldsLocation", "customValuesLocation"])
                              ])
                            ])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_38, [
                          _createVNode(_unref(UICheckbox), {
                            checked: storeAsDefault.value,
                            "onUpdate:checked": _cache[5] || (_cache[5] = ($event: any) => ((storeAsDefault).value = $event))
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", _hoisted_39, _toDisplayString(_ctx.$t('emailBuilder.setDefaultMail')), 1)
                            ]),
                            _: 1
                          }, 8, ["checked"])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_40, [
                      _createElementVNode("div", _hoisted_41, [
                        _createElementVNode("span", _hoisted_42, [
                          _createVNode(_unref(UIButton), {
                            id: "pg-email-builder__test-email-close-btn",
                            onClick: onClickClose
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.$t('common.cancel')), 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _createElementVNode("span", _hoisted_43, [
                          _createVNode(_unref(UIButton), {
                            id: "pg-email-builder__test-email-send-btn",
                            onClick: onClickTestEmail,
                            class: _normalizeClass(["send-test-email inline-flex", {
                        'cursor-not-allowed': !_unref(isValidToAddress),
                        'bg-curious-blue-500 text-white hover:bg-curious-blue-400':
                          _unref(isValidToAddress),
                        'pointer-events-none': sendEmailLoader.value,
                      }]),
                            type: "primary",
                            disabled: !_unref(isValidToAddress),
                            loading: sendEmailLoader.value
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_unref(PlaySquareIcon), { class: "h-5 w-5 mr-2" }),
                              _createElementVNode("span", null, _toDisplayString(_ctx.$t('common.sendTestEmail')), 1)
                            ]),
                            _: 1
                          }, 8, ["class", "disabled", "loading"])
                        ])
                      ])
                    ])
                  ])
                ])), [
                  [_directive_click_outside, showContent.value && onClickClose]
                ])
              : _createCommentVNode("", true)
          ]),
          _: 3
        })
      ])
    ])
  ]))
}
}

})